export { FaviconTags } from './next/components/FaviconTags'
export { iconMetadata } from './next/metadata'
export { getAssetDefaults, setDynamicFavicon } from './lib/util'
export * from '../types'
